import formComponent from '@/util/proto/formComponent'
import LevelTable from './partial/level-table'
import TimeRange from './partial/time-range'
import { createDict } from '@/util/dicts'

const isdef = (d) => typeof d !== 'undefined'

const parseTimeRange = (d) => {
  let ret = []
  try{
    ret = JSON.parse(d)
  }catch(e){

  }
  return ret
}


const timeLabel = (d) => {
  let r = []
  try{
    r = JSON.parse(d.timeStr)
  }catch(e){

  }

  return r.map(i => `${i[0]} - ${i[1]}`).join('; ')
}


const parseLevels = (d) => createDict('companyWarningStrategy').map((i) => {
  let hit = d.find(j => j.level == i.value)
  let ret = {
    name:i.label , level:i.value , color:i.color
  }
  if( hit ){
    ret.scoreMin = hit.scoreMin
    ret.scoreMax = hit.scoreMax
  }
  return ret
})

const strategyState = [{value:1,label:'启用'},{value:0,label:'禁用'}]

export default {
  extends: formComponent ,

  data() {
    return {
      formData: {
       
        name: {
          rules:[
            { required: true, message: '请输入预警名称', trigger: 'blur,change' },
          ]
        },
        codePrefix:{
          rules:[
            { required: true, message: '请输入证照编码前缀', trigger: 'blur,change'},
          ]
        },
        modelType:{
          rules:[
            { required: true, type:'number', message: '请选择证照模板', trigger: 'blur,change'},
          ]
        },
        issueTo: {
          rules:[
            { required: true, type:'number', message: '请选择发行对象', trigger: 'blur,change'},
          ]
        },
        organizationId:{
          rules:[
            { required: true, type:'number',message: '请选择机构', trigger: 'blur,change' },
          ]
        },
        scoreCycle: {
          rules:[
            { type: 'number', required: true, message: '请输入计分周期', trigger: 'blur,change' },
          ]
        },
        scoreTotal: {
          rules:[
            { type: 'number', required: true, message: '请输入周期总分', trigger: 'blur,change' },
          ]
        },
        
        strategy:null,
      },
      id:null,
      loading:false,
      visible:false,
      raw:{},
      state:{
        levels:[],
        timeRange:[],
        organizationName:null,
      },
      api:['companyWarningCreate','companyWarningUpdate'],
    }
  },
  created(){

  },
  computed:{
    title(){
      return this.id ? '修改预警配置' : '新增预警配置'
    },
  },
  methods: {
    init(id) {
      this.id = id

      this.visible = true
      this.state.levels = parseLevels([])
      this.state.timeRange = []

      this.$resetFormData()
      if (this.id) {
        this.query()
      }
    },

    query(){
      this.loading = true
      this.$request.companyWarning(this.id).then(resp => {
        this.$setFormData(resp.data)
        this.raw = resp.data
        
        this.state.levels = parseLevels(resp.data.strategyList)
        this.state.timeRange = parseTimeRange(resp.data.timeStr)

        this.loading = false
      })
    },
    handleChangeOrg(d){
      this.state.organizationName = d.label
    },
    beforeSave(d){
      let {...params} = d
      if(this.id){
        params.id = this.id
      }
      if(this.state.organizationName){
        params.organizationName = this.state.organizationName
      }
      params.timeStr = JSON.stringify(this.state.timeRange)
      params.strategyList = this.state.levels.filter(i => (isdef(i.scoreMin) && isdef(i.scoreMax))).map(i => ({level:i.level, scoreMin:i.scoreMin, scoreMax:i.scoreMax}))
      if( params.strategyList.length == 0 ){
        this.$Message.error('至少需要设置一项预警等级')
        return false
      }
      return params
    }
  },

  render(){
    let enableLevel = this.form ? this.form.getFieldValue('strategy') : null
    let score = this.form ? this.form.getFieldValue('scoreTotal') : Number.MAX_SAFE_INTEGER
    return (
      <sl-side-panel v-model={this.visible} loading={this.loading} title={this.title} loading={this.loading}>
        <sl-form label-width={100}>
          <sl-form-item label="预警名称">
            <Input v-decorator={this.formData.name}></Input>
          </sl-form-item>
          <sl-form-item label="适用机构">
            <sl-select v-decorator={this.formData.organizationId} on-change-data={this.handleChangeOrg} dict="org" />
          </sl-form-item>
          <sl-form-item label="预警时间">
            <TimeRange v-model={this.state.timeRange} />
          </sl-form-item>

          <Divider size="small" style="color:rgba(0,0,0,.65);font-size:13px;margin:24px 0 16px 0;"  orientation="left">预警等级</Divider>
        </sl-form>
        <div>
          <LevelTable v-model={this.state.levels} />
        </div>
        
        <template slot="footer">
          <Button loading={this.loading} on-click={this.$handleSubmit} type="primary">确定</Button>
        </template>
      </sl-side-panel>
    )
  }
}

export const View = {
  data() {
    return {
      id: null,
      loading: false,
      data: {},
      visible: false,
    }
  },
  methods: {

    init(id) {
      this.id = id
      this.visible = true
      this.data = {}
      if (this.id) {
        this.query()
      }
    },

    query() {
      this.loading = true
      this.$request.companyWarning(this.id).then( resp => {
        this.loading = false
        if(resp.code == 0){
          let data = this.$utils.conv(resp.data,{'state':'stateN' , timeLabel})
          data.levels = parseLevels(resp.data.strategyList)
          this.data = data
        }else{
          this.visible = false
          this.$Message.error({ content: resp.msg })
        }
      })
    },
  },
  render(){
    const { loading , data = {}} = this
    return (
      <sl-side-panel destroyOnClose={true} v-model={this.visible} mask-closable={false} title="证照详情" loading={loading}>
        <sl-detail-list col={1} label-width="100px" label-align="right" style="padding:12px;">
          <sl-detail-list-item title="预警名称">{data.name}</sl-detail-list-item>
          <sl-detail-list-item title="适用机构">{data.organizationName}</sl-detail-list-item>
          <sl-detail-list-item title="预警时间">{data.timeLabel}</sl-detail-list-item>
          <sl-detail-list-item title="预警等级">
            <sl-reload condition={this.id}>
              <LevelTable value={data.levels} view />
            </sl-reload>
          </sl-detail-list-item>
        </sl-detail-list>
      </sl-side-panel>
    )
  }
}